var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  SamaData: () => SamaData
});
var import_papaya = __toModule(require("@taxdown/papaya"));
var import_yayoyakiValidator = __toModule(require("../yayoyakiValidator"));
var import_userCardCache = __toModule(require("../../kamiSama/samaCache/userCache/userCardCache"));
const _SamaData = class {
  validateUserData(userData) {
    if (!userData || Object.keys(userData).length === 0) {
      return false;
    }
    if (Object.keys(userData).filter((key) => !key.startsWith(_SamaData.KEY)).length > 0) {
      return false;
    }
    return true;
  }
  constructor(userDataInitial, userData, userCardsCache) {
    if (!this.validateUserData(userData)) {
      throw new Error("Invalid user data");
    }
    this.setUserData(userData);
    this.setUserDataInitial(userDataInitial);
    this.setUserCardsCache(userCardsCache);
  }
  getUserData() {
    return this.userData;
  }
  getUserDataInitial() {
    return this.userDataInitial;
  }
  getUserCardsCache() {
    return this.userCardsCache;
  }
  setUserData(userData) {
    this.userData = userData;
  }
  setUserDataInitial(userDataInitial) {
    this.userDataInitial = userDataInitial;
  }
  setUserCardsCache(userCardsCache) {
    this.userCardsCache = userCardsCache || new import_userCardCache.UserCardCache();
  }
  setUserCardsCacheValue(cardId, index) {
    var _a;
    (_a = this.userCardsCache) == null ? void 0 : _a.setValue(cardId, index);
  }
  deleteUserCardCacheValue(cardId, index) {
    var _a;
    (_a = this.userCardsCache) == null ? void 0 : _a.deleteValue(cardId, index);
  }
  addValues(values) {
    if (!values || values.length === 0) {
      throw new Error("Cannot initialize values if no values are provided");
    }
    let index;
    for (const value of values) {
      const { id, category, validationType, matrix } = value;
      if (category === "visual") {
        continue;
      }
      const defaultValue = import_papaya.default.model.TYPES[validationType].getDefaultValue();
      if (matrix) {
        if (!this.userData[id]) {
          if (index !== void 0 && index !== 0) {
            throw new Error("Cannot add values when yayoyakiSiblings are of different lengths");
          }
          index = 0;
          this.userData[id] = [defaultValue];
        } else {
          if (index !== void 0 && index !== this.userData[id].length) {
            throw new Error("Cannot add values when yayoyakiSiblings are of different lengths");
          }
          index = this.userData[id].length;
          this.userData[id].push(defaultValue);
        }
      } else {
        this.userData[id] = defaultValue;
      }
    }
    return index;
  }
  deleteValues(values, index) {
    if (!values || values.length === 0) {
      throw new Error("Cannot delete values if no values are provided");
    }
    for (const value of values) {
      const { id, category, matrix } = value;
      if (category === "visual") {
        continue;
      }
      if (matrix) {
        if (index === void 0) {
          throw new Error(`${id} cannot delete matrix values without index`);
        }
        if (!Array.isArray(this.userData[id])) {
          throw new Error(`${id} given value is not an array`);
        }
        if (this.userData[id][index] === void 0) {
          throw new Error(`${id} cannot delete matrix values on index that does not exist`);
        }
        if (this.userData[id].length === 1) {
          delete this.userData[id];
        } else {
          this.userData[id].splice(index, 1);
        }
      } else {
        if (index !== void 0) {
          throw new Error(`${id} when deleting a non matrix value, the index must be undefined`);
        }
        delete this.userData[id];
      }
    }
  }
  existsValue(id) {
    return this.userData[id] !== void 0;
  }
  getValue(id, initial = false) {
    return initial ? this.userDataInitial[id] : this.userData[id];
  }
  getValueMatrix(id, index, initial = false) {
    var _a, _b;
    if (index === void 0) {
      throw new Error(`${id} given no index`);
    }
    if (initial) {
      return (_a = this.userDataInitial[id]) == null ? void 0 : _a[index];
    }
    return (_b = this.userData[id]) == null ? void 0 : _b[index];
  }
  getValueScalar(id, initial = false) {
    const value = initial ? this.userDataInitial[id] : this.userData[id];
    if (Array.isArray(value)) {
      throw new Error(`${id} is of matrix value type`);
    }
    return value;
  }
  setValue(id, value, index) {
    if (index === void 0 && Array.isArray(value) === Array.isArray(this.userData[id])) {
      this.userData[id] = value;
      return;
    }
    if (!Array.isArray(this.userData[id])) {
      throw new Error(`${id} is of matrix value but no given index`);
    }
    if (index > this.userData[id].length) {
      throw new Error(`${id} given index is greater than existing matrix value length`);
    }
    this.userData[id][index] = value;
  }
  replaceValues(id, value, originalValue) {
    if (Array.isArray(this.userData[id])) {
      this.userData[id] = this.userData[id].map((v) => v === originalValue ? value : v);
      return;
    }
    this.userData[id] = this.userData[id] === originalValue ? value : this.userData[id];
  }
  sanitizeValues(yayoyakiFormMap) {
    for (const yayoyakiId in this.userData) {
      const yayoyakiForm = yayoyakiFormMap[yayoyakiId];
      if (!yayoyakiForm || yayoyakiForm.category === "visual") {
        continue;
      }
      if (Array.isArray(this.userData[yayoyakiId])) {
        if (this.userData[yayoyakiId].length === 0) {
          this.userData[yayoyakiId][0] = import_yayoyakiValidator.YayoyakiValidator.getFieldDefault(yayoyakiForm);
        }
        for (const index in this.userData[yayoyakiId]) {
          if (this.userData[yayoyakiId][index] === void 0) {
            this.userData[yayoyakiId][index] = import_yayoyakiValidator.YayoyakiValidator.getFieldDefault(yayoyakiForm);
          }
        }
      }
      if (!Array.isArray(this.userData[yayoyakiId])) {
        if (this.userData[yayoyakiId] === void 0) {
          this.userData[yayoyakiId] = import_yayoyakiValidator.YayoyakiValidator.getFieldDefault(yayoyakiForm);
        }
      }
    }
  }
};
let SamaData = _SamaData;
SamaData.KEY = "Y";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SamaData
});
